import React, { Component } from "react";
import "./NoAddPet.component.css";

import { Link } from "react-router-dom";
import { AppLinks } from "../../../constants/app-links";

class NoAddPet extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return(
            <div className="container no-enrollments">
                <div className="row">
                    <div className="d-none d-sm-block col-6 col-sm-5 col-lg-4 px-0">
                        <img
                            className="img-fluid no-enrollments-image"
                            src="../../assets/images/no-enrollments.jpg"
                            alt="worth-the-wait"
                        />
                        </div>
                    <div className="col col-sm-7 col-lg-8">
                        <h1 className="text-primary mb-3 mb-lg-0 sorry">
                            Add a Pet
                        </h1>
                        <p class="">
                        Sorry. We are currently unable to add a pet to your policy! Please <Link to={AppLinks.others.contact}>click here</Link> to contact us.
                        </p>
                        <button
                            className="button-primary back-to-home"
                            type="submit"
                            onClick={this.props.backToHome}
                            >
                            Home
                            </button>
                    </div>
                </div>
            </div>
        );
    }
}
  
export default NoAddPet;